module.exports = __webpack_public_path__ + "media/images/new-sprint-icon-bd2e297e.png";